var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounToilet7561836(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m194.39 732h48v264h48v-312h-48v-264h168v264h-48v312h48v-264h48v-360h-264z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m326.39 348c46.312 0 84-37.688 84-84s-37.688-84-84-84-84 37.688-84 84 37.688 84 84 84zm0-120c19.781 0 36 16.219 36 36s-16.219 36-36 36-36-16.219-36-36 16.219-36 36-36z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m926.39 605.16v-233.16h-216v233.16l-79.312 126.84h103.31v264h48v-312h-64.781l40.781-65.156v-198.84h120v198.84l40.688 65.156h-64.688v312h48v-264h103.22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m818.39 348c46.312 0 84-37.688 84-84s-37.688-84-84-84-84 37.688-84 84 37.688 84 84 84zm0-120c19.781 0 36 16.219 36 36s-16.219 36-36 36-36-16.219-36-36 16.219-36 36-36z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m554.39 168h48v864h-48z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounToilet7561836);
export default __webpack_public_path__ + "static/media/noun-toilet-7561836.a680fc6470c46186ffb5e3633904fc32.svg";
export { ForwardRef as ReactComponent };